<template>
  <div class="head headDefault head_default">
    <div class="head-main">
      <div class="head-left">
        <div class="head-icon head-logo">
          <img src="../../assets/img/pic_logo.png" alt />
        </div>
      </div>
      <div class="head-right">
        <div class="head-rightTop head_top">
          <ul>
            <router-link to="/" tag="li" class="topNav">官网首页</router-link>
            <router-link to="/user/help" tag="li" class="topNav">帮助中心</router-link>
            <router-link to="/user/message" tag="li" class="topNav">
              <el-badge :value="0" :hidden="$store.state.badge" class="news_num">
                <svg class="icon iconicon_nav_mes" aria-hidden="true">
                  <use xlink:href="#iconicon_nav_mes" />
                </svg>消息
              </el-badge>
            </router-link>
            <li class="topNav">
              <img :src="!$store.state.userAvatar?defaultAvatar:$store.state.userAvatar" alt @click="openOrderList()" /> <div @click="openOrderList()">{{$store.state.userName}}</div> <span @click="logout()">退出</span> 
            </li>
          </ul>
        </div>
        <div class="head-rightBottom head_bottom">
          <li
            class="bottomNav bot_nav"
            v-for="(item, index) in $store.state.headerTabList"
            :key="index"
            :class="{bot_selected:item.isSelected}"
            @click="toUrl(item)"
          >{{item.name}}</li>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabList: [
        { name: "关于我们", isSelected: false },
        { name: "维权中心", isSelected: false },
        { name: "我的钱包", isSelected: false },
        { name: "我的订单", isSelected: false },
        { name: "首页", isSelected: true }
      ],
      defaultAvatar:require("@/assets/img/pic_head_nor.png")
    };
  },
  mounted() {
    if(Cookies.get('token')==undefined){
      this.$message("请先登录");
      this.$router.push({ path: "/login" });
    }
    Cookies.get('token');
  },
  methods: {
    toUrl(item) {
      var _this = this;
      for (let i of _this.$store.state.headerTabList) {
        i.isSelected = false;
      }
      item.isSelected = !item.isSelected;
      if (item.name == "首页") {
        _this.$router.push({ path: "/user/index" });
      }
      if (item.name == "我的订单") {
        _this.$router.push({ path: "/user/order" });
      }
      if (item.name == "我的钱包") {
        _this.$router.push({ path: "/user/wallet" });
      }
      if (item.name == "维权中心") {
        _this.$router.push({ path: "/user/right" });
      }
      if (item.name == "关于我们") {
        _this.$router.push({ path: "/user/about" });
      }
    },
    // 退出登录
    logout() {
      let _this=this;
      this.$confirm("你确定要退出聚师傅吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$message({
          type: "success",
          message: "退出成功!"
        });
        _this.$store.state.userName = "";
          _this.$store.state.userPhone = "";
          _this.$store.state.userAvatar = "";
          _this.$store.state.hasPwd = "";
          _this.$store.state.userInfo = "";
        this.$store.state.login = false;
        Cookies.remove('token', { path: '/' });
        this.$router.push({ path: "/" });
      });
    },
  }
};
</script>

<style lang="scss">
.news_num {
  vertical-align: top !important;
  .iconicon_nav_mes {
    width: 16px;
    height: 16px;
    padding-top: 2px;
  }
  .el-badge__content.is-fixed {
    top: 13px;
    width: 10px;
    height: 10px;
    right: 7px;
    color: transparent;
    background: #f75658;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 5px;
  }
}
</style>
<style lang="scss" scoped>
@import "./../_headTop.scss";
</style>
<style lang="scss" scoped>
.head_top {
  li.topNav {
    // color: #5e6066 !important;
    color: #fff !important;
  }
}
.head_bottom {
  li.bottomNav {
    // color: #2f3133 !important;
    color: #fff !important;
  }
  li.bot_nav:hover {
    // color: #3455d3 !important;
    border-bottom: 2px solid #fff !important;
  }
  li.bot_selected {
    // color: #3455d3 !important;
    border-bottom: 2px solid #fff !important;
  }
}
.head_default {
  // background: #fff;
  background: #3455D3;
}
.head_default {
  border-bottom: 1px solid #dfe4eb;
  .head-logo{
    height: 58px;
  }
}
</style>